// Precheck source versions use SAP's Version field, target versions use targetVersion.
// Unknown versions are never inferred equal. Status remains unchanged for display.
export function hasSameVersion(artifact) {
  const source = artifact?.Version ?? artifact?.srcVer;
  const target = artifact?.targetVersion ?? artifact?.tgt;
  return typeof source === "string" && source.trim() && typeof target === "string" && target.trim()
    ? source.trim() === target.trim() : false;
}
export function needsSameVersionPermission(artifact) {
  return artifact?.status === "identical" || hasSameVersion(artifact);
}

export function wasSameVersionSelected(precheck, selection, artifact, plantKey) {
  const id = artifact.originalId || artifact.Id;
  if (!selection?.[id]?.[plantKey]) return false;
  const previous = Object.values(precheck || {}).filter(entry => (entry.werk?.kennung || "std") === plantKey)
    .flatMap(entry => entry.comparison || []).find(item => (item.originalId || item.Id) === id);
  return !!previous && needsSameVersionPermission(previous)
    && previous.Version === artifact.Version && previous.targetVersion === artifact.targetVersion;
}

export function isArtifactDraft(artifact) {
  return artifact?.draft === true || artifact?.status === "draft" || String(artifact?.Version || "").trim().toLowerCase() === "draft";
}

export function referenceVersions(reference) {
  return {
    Version: reference?.version ?? reference?.Version ?? reference?.srcVer ?? reference?.srcVersion,
    targetVersion: reference?.targetVersion ?? reference?.tgtVer,
  };
}

export function needsSameReferenceVersionPermission(reference) {
  return String(reference?.status || "").toLowerCase() === "identical" || hasSameVersion(referenceVersions(reference));
}

export function sameReferenceVersionPair(previous, current) {
  if (!previous || !needsSameReferenceVersionPermission(previous)) return false;
  const before = referenceVersions(previous), after = referenceVersions(current);
  return before.Version === after.Version && before.targetVersion === after.targetVersion;
}
